const ContactInfo = () => {
  return (
    <div className="flex flex-col gap-8">
      {/* Contact Card - 명함 */}
      <div className="bg-[#F7F8F9] rounded-2xl p-10 flex flex-col gap-6">
        <div className="flex items-center gap-3">
          <span className="w-8 h-1 bg-[#E8521A] rounded-full" />
          <span
            className="text-[#E8521A] text-xs font-black tracking-widest uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Contact
          </span>
        </div>

        {/* 명함 이미지 */}
        <div className="w-full rounded-xl overflow-hidden" style={{ aspectRatio: '1.75 / 1' }}>
          <img
            src="https://storage.readdy-site.link/project_files/d31872dc-7cf6-4f95-8c43-db2c1b6d36b6/623262dc-baa0-4fa2-8464-4dca3241fad6_unnamed.jpg?v=3cfacc9b218aa8ef2dbfab87806b1ada"
            alt="대표 명함"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      {/* Map */}
      <div className="rounded-2xl overflow-hidden" style={{ height: '260px' }}>
        <iframe
          title="본사 위치 - 경북 안동시 풍천면 천년숲동로 46"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.0!2d128.5833!3d36.5833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3565b5a1e2e2e2e3%3A0x0!2z6rK96riw64-EIOyEseuCqOyLnCDtmZTsoJXrjIDsgrDroZwgNDY!5e0!3m2!1sko!2skr!4v1700000000000!5m2!1sko!2skr"
          width="100%"
          height="260"
          style={{ border: 0, display: 'block' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* SNS / QR Row */}
      <div className="grid grid-cols-2 gap-4">
        {/* Instagram */}
        <div className="bg-[#F7F8F9] rounded-2xl p-6 flex flex-col items-center gap-3">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#f09433] via-[#e6683c] to-[#bc1888]">
            <i className="ri-instagram-line text-white text-2xl" />
          </div>
          <p
            className="text-[#1B2A4A] text-sm font-bold text-center"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            Instagram
          </p>
          <p
            className="text-[#1B2A4A]/40 text-xs font-medium text-center"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            링크를 연결해 주세요
          </p>
        </div>

        {/* Blog QR */}
        <div className="bg-[#F7F8F9] rounded-2xl p-6 flex flex-col items-center gap-3">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1B2A4A]">
            <i className="ri-qr-code-line text-white text-2xl" />
          </div>
          <p
            className="text-[#1B2A4A] text-sm font-bold text-center"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            블로그 QR
          </p>
          <p
            className="text-[#1B2A4A]/40 text-xs font-medium text-center"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            QR 이미지를 넣어주세요
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
